<template>
  <app-layout title="Billing">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <br />
      <!-- progress bar start from here -->
      <upgrade-progressstep step="2"></upgrade-progressstep>
      <!-- progress end  -->

      <br />
      <section>
        <div class="container">
          <div class="gap-4" style="display: flex">
            <!-- left side end -->
            <div
              class="bigitem border-2 border-grey-600 bg-white mb-4 left-cont"
            >
              <!-- left billing -->

              <div
                class="font-semibold text-lg text-left mx-4  pt-4 leading-none"
              >
                Billing Details
              </div>
              <h6 class="text-left mx-4 text-sm mb-2 leading-none">
                Select a billing account to process or
                <a @click="showCreatePopup()" href="#" class="text-green-500"
                  >create new</a
                >
              </h6>

              <div class="mx-4 mb-3">
                <!-- cards 1 start -->
                <DxScrollView width="100%" height="100%">
                  <div v-for="(value, key) in ledgerData">
                    <label
                      v-if="value.rlt_cnslledger_cnsladdress.length"
                      v-for="(v, k) in value.rlt_cnslledger_cnsladdress"
                      @click="getSelectedData(value.id, v.id)"
                      class="card"
                    >
                      <input name="plan" class="radios" type="radio" />
                      <span class="text-left plan-details">
                        <div class="font-semibold text-lg">
                          {{ value.name }}
                        </div>
                        <span class="cursor-pointer mt-2 text-gray-500">
                          {{
                            v.street +
                            " , " +
                            v.area +
                            "," +
                            v.landmark +
                            "," +
                            v.city +
                            "," +
                            v.state +
                            "," +
                            v.pin_code
                          }}
                        </span>
                      </span>
                    </label>
                  </div>
                </DxScrollView>
              </div>
            </div>
            <!-- left side end -->
            <!-- ... -->
            <!-- right side start -->
            <div
              class="smallitem first-of-type:border-2 border-grey-600 bg-white mb-4 right-cont"
            >
              <div class="mx-4 my-4">
                <div class="flex justify-between">
                  <div class="font-semibold text-lg">Product Details</div>
                  <i class="dx-icon-edit"></i>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-500 text-sm">Product Family</span>
                  <span class="text-gray-500 text-sm">{{
                    selectedProductFamilyName
                  }}</span>
                </div>

                <div class="flex justify-between">
                  <span class="text-gray-500 text-sm">Subsciption Plan</span>
                  <span class="text-gray-500 text-sm">{{
                    sideSubPlanName
                  }}</span>
                </div>

                <div class="flex justify-between border-b-2 border-gray-600">
                  <span class="text-gray-500 text-sm">Subsciption Price</span>
                  <span class="text-gray-500 text-sm">{{ sideSubPrice }}</span>
                </div>

                <div class="flex justify-between mt-2">
                  <div class="font-semibold text-lg">Organisation</div>
                  <i class="dx-icon-edit"></i>
                </div>
                <div class="flex justify-between border-b-2 border-gray-600">
                  <span class="text-gray-500 text-sm">{{
                    sideAccountName
                  }}</span>
                </div>

                <div class="flex justify-between mt-2">
                  <div class="font-semibold text-lg">Host</div>
                  <i class="dx-icon-edit"></i>
                </div>

                <div class="flex justify-between border-b-2 border-gray-600">
                  <span class="text-gray-500 text-sm">{{
                    sideTenantName
                  }}</span>
                </div>

                <div class="flex justify-between mt-4">
                  <!-- <jet-responsive-nav-link
                    @click="goToHost()"
                    type="button"
                    class="rounded-md font-bold text-gray-700 px-4 py-2"
                    style="background-color: #cdcdcd"
                  >
                    <i class="dx-icon-chevrondoubleleft"></i>

                    Back
                  </jet-responsive-nav-link> -->
                  <jet-responsive-nav-link
                    @click="goToOrderPage()"
                    type="button"
                    class="rounded-md font-bold bg-green-500 text-white px-4 py-2"
                  >
                    Next
                    <i class="dx-icon-chevrondoubleright"></i>
                  </jet-responsive-nav-link>
                </div>
              </div>
            </div>
            <!-- Right end -->
          </div>
          <!-- pop up for quick create -->
          <DxPopup 
            v-model:visible="createPopupVisible"
            :drag-enabled="true"
            :show-close-button="true"
            :close-on-outside-click="false"
            :width="600"
            :height="380"
            :show-title="true"
            :resizeEnabled="true"
            titleTemplate="title"
          >
          
            <template #title>
              <div class="flex justify-between items-center ">
              <div class="">
                <h6 class="font-semibold ">
                 Add Billing Address
                </h6>
                  <p class="text-xs text-gray-500">Title Template</p>
              </div>

                <DxButton
                  icon="close" 
                  @click="createPopupVisible = false" 
                  styling-mode="text"
                />
              </div>
            </template>
            

           
            <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              :options="closeButtonOptions"
            />
            <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              :options="saveButtonOptions"
            />
             
            <DxScrollView width="100%" height="100%">
             
              <div class=" mt-2 text-sm font-semibold  py-2">
                Billing Account
              </div>
                <!-- checkbox -->
              
                  <!-- <div class="dx-field-label">Unchecked</div> -->
                  <div class="">
                    <DxCheckBox
                      text="Create New Billing Account"
                      :value="false"
                      :element-attr="unCheckedLabel"
                      @valueChanged="changeSelectionPriority" 
                    />
                   
                  </div>
              <div class="mt-2" v-show="showBilingForm" >
                <BsOnBoardForm
                  :routeDef="this.routeDef"
                  :createDef="this.billingDef"
                  :modelData="modelData"
                  ref="onboardbillingRenderer"
                  v-model="billingModel"
                  
                />
              </div>

              <div class="mt-2" v-show="!showBilingForm">
                <!-- <OnBoardRelateDataGrid
                  v-model="quickBillingSelection"
                  ref="dropDatagrid"
                  :rltId="this.accountId"
                  rRouteUrl="/onboard/rlt_account_ledger"
                >
                </OnBoardRelateDataGrid> -->

                <OnBoardRelateComponent
                  v-model="quickBillingSelection"
                  rRouteUrl="/marketplaces/onboard/rlt_account_ledger"
                  componentLabel="Search Account:"
                  ref="dropDatagrid"
                  v-on:changed="inputChanged()"
                >
                </OnBoardRelateComponent>
              </div>

              <div class=" my-2 text-sm font-semibold  py-2">
                Address
              </div>

              <BsOnBoardForm
                :routeDef="this.routeDef"
                :createDef="this.addressDef"
                :modelData="modelData"
                ref="onboardformRenderer"
              />
            </DxScrollView>
          </DxPopup>
        </div>
      </section>
    </div>
  </app-layout>
</template>

<script>
import { DxCheckBox } from 'devextreme-vue/check-box';
import UpgradeProgressstep from "../Views/Components/UpgradeProgressbar.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxRadioGroup from "devextreme-vue/radio-group";
import OnBoardRelateDataGrid from "@/components/OnBoardRelateDataGrid.vue";
import OnBoardRelateComponent from '@/components/OnBoardRelateComponent.vue';
import DxButton from 'devextreme-vue/button';

import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import { mergeProps } from "vue";
export default {
  props: {
    productId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptionPriceId: String,
    accountId: String,
    sideAccountName: String,
    sideSubPrice: String,
    sideSubPlanName: String,
    sideProductName: String,
    sideTenantName: String,
    selectedProductFamilyName:String,
    subscriptionProductId:String,

    billingDef: {
      type: Array,
      default: [],
    },
    addressDef: {
      type: Array,
      default: [],
    },

    ledgerData: Object,
  },
  components: {
    UpgradeProgressstep,
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxPaging,
    BsOnBoardForm,
    DxScrollView,
    DxRadioGroup,
    OnBoardRelateDataGrid,
    OnBoardRelateComponent,
    DxButton,
    DxCheckBox
  },
  data() {
    return {
      title: "Billing",
      combinedQuery: "",
      routeDef: "ledgers",
      selectedBillingId: null,
      selectedAddressId: null,
      createPopupVisible: false,
      showBilingForm: false,
      labelLocation: "top",
      quickBillingSelection: null,
      billingModel: null,
    
    
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.createPopupVisible = false;
        },
      },

      saveButtonOptions: {
       
       text: "Save",
       onClick: this.saveRecord,
       elementAttr: {
       style: "background-color: #10B981; color: white;"
     }
     },
    };
  },
  methods: {
    refreshData() {
     // this.$refs.onboardformRenderer.instance.resetValues();
     // this.$refs.onboardbillingRenderer.instance.resetValues();
    this.$refs.onboardbillingRenderer.formData ={};
    this.$refs.onboardformRenderer.formData ={};
    //  this.$refs["onboardformRenderer"].instance.refresh();
     // this.$refs["onboardbillingRenderer"].instance.refresh();
    },
    goToOrderPage() {
      var data = {
        productId: this.productId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptionPriceId: this.subscriptionPriceId,
        organisationId: this.organisationId,
        billingId: this.selectedBillingId,
        billingAddressId: this.selectedAddressId,
        accountId: this.accountId,
        sideProductName: this.sideProductName,
        sideSubPlanName: this.sideSubPlanName,
        sideSubPrice: this.sideSubPrice,
        sideAccountName: this.sideAccountName,
        sideTenantName: this.sideTenantName,
        selectedProductFamilyName:this.selectedProductFamilyName,
        subscriptionProductId:this.subscriptionProductId,

      };
      if (this.selectedBillingId != null) {
        this.$inertia.post(route("marketplaces.placeorder"), data);
      } else {
        alert("Please Select Any Billing Id !! ");
      }
    },
    moveToBillingCreate() {
      alert("Wait for this features we are working on it");
      //this.$inertia.get("billingacc/create");
    },
    saveRecord() {
      var data = {
        addressData: this.$refs.onboardformRenderer.formData,
        accountId: this.accountId,
        billingId: this.quickBillingSelection,

        billingData: this.$refs.onboardbillingRenderer.formData,
      };

      // this.$refs.onboardformRenderer.formData.accountId = this.accountId;
      // console.log("datagridValue",this.quickBillingSelection);
      // console.log("Billing Form Value",this.$refs.onboardbillingRenderer.formData);

      this.$inertia.post(route("marketplaces.onboard.ledgers", data));
       //this.refreshData();
      this.createPopupVisible = false;
    },
    goToHost() {
      var data = {
        productId: this.productId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptionPriceId: this.subscriptionPriceId,
        accountId: this.accountId,
        sideProductName: this.sideProductName,
        sideSubPlanName: this.sideSubPlanName,
        sideSubPrice: this.sideSubPrice,
      };

      this.$inertia.post(route("marketplaces.organisations"), data);
    },
    showCreatePopup() {
      this.createPopupVisible = true;
    },
    showCreateAddPopup() {
      this.createAdPopupVisible = true;
    },

    showBillingAddress(position, selectedBillingId) {
      this.billingAddressData =
        this.ledgerData[position].rlt_cnslledger_cnsladdress;
      this.selectedBillingId = selectedBillingId;
      this.isHidden = false;
    },
    getSelectedData(billingId, addressId) {
      //console.log("SelectedBillingId",billingId);
      //console.log("SelectedAddressId",addressId);
      this.selectedBillingId = billingId;
      this.selectedAddressId = addressId;
    },
    changeSelectionPriority(e) {
      if (e.value == 1) {
        this.showBilingForm = true;
        this.formDef = this.billingDef;
      } else {
        this.showBilingForm = false;

        this.formDef = [
          {
            editorOptions: [],
            validationRules: [],
            editorType: "Relate",
            name: "name",
            vname: "LBL_OTHER_RELATE",
            label: "Billing",
            rmodule: "Ledger",
          },
        ];
      }
    },
  },
  mounted() {
    formDef: [];
  },

  // computed: {
  //   unCheckedLabel() {
  //     return { 'aria-label': 'Unchecked' };
  //   },
  // }
};
</script>
<style>

 p{
  margin-bottom: 0.2rem;
}
h6{
  margin-bottom: -0.1rem;
}

#elip {
  overflow: hidden;
  width: 260px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome and Opera */
}
/* .img-company {
  width: 50px;
  height: 50px;
} */
.no-decoration {
  text-decoration: none;
}
.no-decoration:hover {
  text-decoration: none;
}

/* after steps */
.card {
  background-color: #fff;
  border-radius: var(--card-radiuss);
  position: relative;
}
.card:hover {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
}
.radios {
  font-size: inherit;
  margin: 0;
  position: absolute;
  right: calc(var(--card-paddings) + var(--radio-border-widths)) !important;
  top: calc(var(--card-paddings) + var(--radio-border-widths));
}
@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  .radios {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: #fff;
    border: var(--radio-border-widths) solid var(--color-gray);
    border-radius: 50%;
    cursor: pointer;
    height: var(--radio-sizes);
    outline: none;
    transition: background 0.2s ease-out, border-color 0.2s ease-out;
    width: var(--radio-sizes);
  }
  .radios::after {
    border: var(--radio-border-widths) solid #fff;
    border-top: 0;
    border-left: 0;
    content: "";
    display: block;
    height: 0.75rem;
    left: 25%;
    position: absolute;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -50%);
    width: 0.375rem;
  }
  .radios:checked {
    background: var(--color-green);
    border-color: var(--color-green);
  }
  .card:hover .radios {
    border-color: var(--color-dark-gray);
  }
  .card:hover .radios:checked {
    border-color: var(--color-green);
    --tw-ring-color: rgba(27, 243, 167, 0.886);
    background: var(--color-green);
  }
}
[type="radio"] {
  color: var(--color-green);
}
input[type="radio"] {
  --tw-ring-color: rgba(27, 243, 167, 0.886) !important;
}

.plan-details {
  border: var(--radio-border-widths) solid var(--color-gray);
  border-radius: var(--card-radiuss);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: var(--card-paddings);
  transition: border-color 0.2s ease-out;
}
.card:hover .plan-details {
  border-color: var(--color-dark-gray);
}
.radios:checked ~ .plan-details {
  border-color: var(--color-green);
}
.radios:focus ~ .plan-details {
  box-shadow: 0 0 0 2px var(--color-dark-gray);
}
.radios:disabled ~ .plan-details {
  color: var(--color-dark-gray);
  cursor: default;
}

.card:hover .radios:disabled ~ .plan-details {
  border-color: var(--color-gray);
  box-shadow: none;
}
.card:hover .radios:disabled {
  border-color: var(--color-gray);
}
.hidden-visually {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
:root {
  --card-line-height: 1.2em ;
  --card-paddings: 1em ;
  --card-radiuss: 0.5em ;
  --color-green: #0ecb8f;
  --color-gray: #e2ebf6;
  --color-dark-gray: #c4d1e1;
  --radio-border-widths: 2px;
  --radio-sizes: 1.5em;
}
.bigitem {
  /* This will be twice as big as the small item. */
  -webkit-flex: 2 0 0;
  flex: 2 0 0;
  height: 15%;
  min-height: 200px;
}

.smallitem {
  -webkit-flex: 1 0 0;
  flex: 1 0 0;
  height: 20%;
  min-height: 200px;
}
</style>

